import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
    <h1 className="font-heading font-bold text-4xl text-slate-900">404</h1>
    <p className="text-slate-600 mt-2">Page not found</p>
    <Link to="/" className="mt-6 text-primary font-semibold hover:underline">
      Go home
    </Link>
  </div>
);

export default NotFoundPage;
